export default __webpack_public_path__ + "static/media/fb-circle.378c53a1.svg";